export interface IAvatarAssetColorsMapPermanentColorItem {
    srcColor: string;
    dstColor: string;
}
